export const UrlValidate = (values, fileExtension) => {
    let errors = {};
    const urlRegex = /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;


    if (!values.file) {
        errors.file = "URL is required.";
    } else {
        // Check if the URL matches the regex
        // if (!urlRegex.test(values.file)) {
        //     errors.file = "URL must be a valid URL.";
        // }

        // Dynamically validate based on the file extension
        if (fileExtension && !values.file.endsWith(fileExtension)) {
            errors.file = `URL must end with ${fileExtension}`;
        }
    }

    return errors;
};
